<aran-page-title
  [headerConfig]="{
    bannerTitle: routeMetaData.requests.title,
    subtitle: 'Detailed information',
    baseUrl: routeMetaData.requests.link
  }"
  [dropdownConfig]="{
    isVisibleButton: requestDetail?.status === 'Pending' && true,
    buttonName: 'Actions',
    menu: actionMenuComponent.menu
  }"
></aran-page-title>

<aran-menu #actionMenuComponent [menuItems]="menuItems"></aran-menu>

<section
  *ngIf="(isLoading$ | async) === false && requestDetail as requestDetail"
  class="request-details"
>
  <div
    fxLayout="row"
    fxLayoutAlign="space-between end"
    class="request-details-banner"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="request-details-banner__title">Services</div>
    </div>
    <div class="request-details-banner__status-container">
      <div
        class="request-details-banner__status-container--status"
        [ngStyle]="{ background: getStatusColor(requestDetail.status) }"
      >
        {{ requestDetail.status }}
      </div>
      <div class="request-details-banner__status-container--date">
        {{
          requestDetail.status === "Pending"
            ? requestDetail.creationDate
            : requestDetail.modifiedDate
        }}
      </div>
    </div>
  </div>

  <div class="request-details__detail-container">
    <div
      class="account__service-category"
      *ngFor="let item of requestDetail.topics; let i = index"
    >
      <div class="account__service-category-title" fxLayout="row">
        {{ item.description }}
      </div>

      <div class="flex-col">
        <ng-container *ngIf="!item?.topicAreas?.length">
          <ng-container
            *ngTemplateOutlet="scenariosContentTemplate"
          ></ng-container>
        </ng-container>

        <ng-template #scenariosLabel>
          <div
            aranBadge
            aranBadgeSize="x-small"
            [aranBadgeShow]="
              item.newSubTopicSelectedOption !==
                item.oldSubTopicSelectedOption ||
              (item.newSubTopicSelectedOption === 'Custom' &&
                item.oldSubTopicSelectedOption === 'Custom' &&
                getBadgeCount(item.subTopics) !== '0')
            "
          >
            Scenarios
          </div>
        </ng-template>

        <ng-template #airportsLabel>
          <div
            aranBadge
            aranBadgeSize="x-small"
            [aranBadgeShow]="
              item.newTopicAreaSelectedOption !==
                item.oldTopicAreaSelectedOption ||
              (item.newTopicAreaSelectedOption === 'Custom' &&
                item.newTopicAreaSelectedOption === 'Custom' &&
                getBadgeCount(
                  item.topicAreas | areaType : ['Aerodrome', 'Heliport']
                ) !== '0')
            "
          >
            Airports
          </div>
        </ng-template>

        <ng-template #airspaceLabel>
          <div
            aranBadge
            aranBadgeSize="x-small"
            [aranBadgeShow]="
              getBadgeCount(item.topicAreas | areaType : 'Airspace') !== '0'
            "
          >
            FIRs
          </div>
        </ng-template>

        <aran-tabs
          *ngIf="item?.topicAreas?.length"
          [tabs]=" [
              {
                label: scenariosLabel,
                template: scenariosContentTemplate,
              },
              {
                label: airportsLabel,
                template: airportsContentTemplate,
              },
              {
                label: airspaceLabel,
                template: firsContentTemplate,
              },
            ]"
          [selectedIndex]="selectedIndexes[i]"
          (tabChanged)="onTabChanged($event, i)"
          [design]="'underline'"
          [fitInkBarToContent]="true"
          [stretchTabs]="false"
          [alignTabs]="'start'"
          [dynamicHeight]="false"
          [animationDuration]="'300ms'"
          [ignoreContentAnimation]="true"
        >
        </aran-tabs>

        <ng-template #scenariosContentTemplate>
          <div
            class="border-bottom py-3 flex"
            *ngIf="
              item.subTopics.length > 1 &&
              (item.newSubTopicSelectedOption === 'Custom' ||
                item.oldSubTopicSelectedOption === 'Custom')
            "
          >
            <div class="detailTableSearchContainer">
              <aran-input
                type="text"
                label="Search"
                fxFlex="100%"
                [outline]="true"
                [isClearable]="true"
                [(ngModel)]="filters[getScenarioKey(i)]"
                [ngModelOptions]="{ standalone: true }"
                (input)="applyFilter(getScenarioKey(i))"
                (handleReset)="resetFilter(getScenarioKey(i))"
              ></aran-input>
            </div>
          </div>

          <div
            class="px-4 pt-4 account__serviceSelectedOption"
            *ngIf="
              item.newSubTopicSelectedOption &&
              item.newSubTopicSelectedOption !== 'Custom' &&
              item.newSubTopicSelectedOption !== 'None' &&
              item.newSubTopicSelectedOption !== item.oldSubTopicSelectedOption
            "
          >
            <div class="add_request">
              {{ item.newSubTopicSelectedOption }}
            </div>
          </div>

          <div
            class="px-4 pt-4 account__serviceSelectedOption"
            *ngIf="
              item.oldSubTopicSelectedOption &&
              item.oldSubTopicSelectedOption !== 'Custom' &&
              item.oldSubTopicSelectedOption !== 'None' &&
              item.newSubTopicSelectedOption !== item.oldSubTopicSelectedOption
            "
          >
            <div class="removed_request line-decoration">
              {{ item.oldSubTopicSelectedOption }}
            </div>
          </div>

          <ng-container
            *ngIf="
              item.newSubTopicSelectedOption === 'None' &&
              item.oldSubTopicSelectedOption === 'None'
            "
          >
            <ng-container
              *ngTemplateOutlet="noInfoFoundTemplate"
            ></ng-container>
          </ng-container>

          <div
            class="px-4 pt-4 account__serviceSelectedOption"
            *ngIf="
              item.oldSubTopicSelectedOption &&
              item.oldSubTopicSelectedOption !== 'Custom' &&
              item.oldSubTopicSelectedOption !== 'None' &&
              item.newSubTopicSelectedOption === item.oldSubTopicSelectedOption
            "
          >
            <div>
              {{ item.newSubTopicSelectedOption }}
            </div>
          </div>

          <div
            class="px-4 pt-2 account__serviceSelectedOption"
            *ngIf="
              item.oldSubTopicSelectedOption === 'Custom' ||
              item.newSubTopicSelectedOption === 'Custom'
            "
          >
            <div
              [ngClass]="{
                add_request:
                  item.newSubTopicSelectedOption === 'Custom' &&
                  item.oldSubTopicSelectedOption !== 'Custom',
                'removed_request line-decoration':
                  item.oldSubTopicSelectedOption === 'Custom' &&
                  item.newSubTopicSelectedOption !== 'Custom'
              }"
            >
              Custom
            </div>
          </div>

          <div
            *ngIf="
              item.oldSubTopicSelectedOption === 'Custom' ||
              item.newSubTopicSelectedOption === 'Custom'
            "
          >
            <div
              class="account__service-value"
              fxLayout="column"
              fxLayoutAlign="start start"
              *ngIf="item.subTopics.length; else noInfoFoundTemplate"
            >
              <ng-container
                *ngIf="
                  (
                    item.subTopics
                    | filterBySubTopicStatus
                      : item.oldSubTopicSelectedOption
                      : item.newSubTopicSelectedOption
                    | filterByText : filters[getScenarioKey(i)] : 'description'
                  ).length;
                  else noInfoMatchedFoundTemplate
                "
              >
                <div
                  *ngFor="
                    let service of item.subTopics
                      | filterBySubTopicStatus
                        : item.oldSubTopicSelectedOption
                        : item.newSubTopicSelectedOption
                      | filterByText
                        : filters[getScenarioKey(i)]
                        : 'description'
                      | paginate : pagingConfig[getScenarioKey(i)]
                  "
                >
                  <ng-container
                    *ngIf="
                      !(
                        (item.newSubTopicSelectedOption === 'Custom' &&
                          item.oldSubTopicSelectedOption !== 'Custom' &&
                          service.status === 'Remove') ||
                        (item.oldSubTopicSelectedOption === 'Custom' &&
                          item.newSubTopicSelectedOption !== 'Custom' &&
                          service.status === 'Add')
                      )
                    "
                  >
                    <div class="flex items-center">
                      <mat-icon
                        *ngIf="
                          item.newSubTopicSelectedOption === 'Custom' ||
                          item.oldSubTopicSelectedOption === 'Custom'
                        "
                        class="mr-2"
                        [ngClass]="{
                          add_request:
                            (item.newSubTopicSelectedOption === 'Custom' &&
                              item.oldSubTopicSelectedOption !== 'Custom') ||
                            (item.newSubTopicSelectedOption === 'Custom' &&
                              item.oldSubTopicSelectedOption === 'Custom' &&
                              service.status === 'Add'),
                          removed_request:
                            (item.oldSubTopicSelectedOption === 'Custom' &&
                              item.newSubTopicSelectedOption !== 'Custom') ||
                            (item.newSubTopicSelectedOption === 'Custom' &&
                              item.oldSubTopicSelectedOption === 'Custom' &&
                              service.status === 'Remove')
                        }"
                      >
                        {{
                          (item.newSubTopicSelectedOption === "Custom" &&
                            item.oldSubTopicSelectedOption !== "Custom") ||
                          (item.newSubTopicSelectedOption === "Custom" &&
                            item.oldSubTopicSelectedOption === "Custom" &&
                            service.status === "Add")
                            ? "add"
                            : (item.oldSubTopicSelectedOption === "Custom" &&
                                item.newSubTopicSelectedOption !== "Custom") ||
                              (item.newSubTopicSelectedOption === "Custom" &&
                                item.oldSubTopicSelectedOption === "Custom" &&
                                service.status === "Remove")
                            ? "remove"
                            : ""
                        }}
                      </mat-icon>

                      <span
                        [ngClass]="{
                          current_request: service.status === 'Current',
                          add_request:
                            (item.newSubTopicSelectedOption === 'Custom' &&
                              item.oldSubTopicSelectedOption !== 'Custom') ||
                            (item.newSubTopicSelectedOption === 'Custom' &&
                              item.oldSubTopicSelectedOption === 'Custom' &&
                              service.status === 'Add'),
                          'removed_request line-decoration':
                            (item.oldSubTopicSelectedOption === 'Custom' &&
                              item.newSubTopicSelectedOption !== 'Custom') ||
                            (item.newSubTopicSelectedOption === 'Custom' &&
                              item.oldSubTopicSelectedOption === 'Custom' &&
                              service.status === 'Remove')
                        }"
                      >
                        {{ service.description }}
                      </span>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>

            <div
              class="mt-4 w-full"
              *ngIf="
                (
                  item.subTopics
                  | filterBySubTopicStatus
                    : item.oldSubTopicSelectedOption
                    : item.newSubTopicSelectedOption
                  | filterByText : filters[getScenarioKey(i)] : 'description'
                ).length > itemsPerPage
              "
            >
              <aran-pagination
                [uniqueKey]="getScenarioKey(i)"
                [totalItems]="
                  (
                    item.subTopics
                    | filterBySubTopicStatus
                      : item.oldSubTopicSelectedOption
                      : item.newSubTopicSelectedOption
                    | filterByText : filters[getScenarioKey(i)] : 'description'
                  ).length
                "
                [currentPage]="pagingConfig[getScenarioKey(i)].currentPage"
                [itemsPerPage]="pagingConfig[getScenarioKey(i)].itemsPerPage"
                [pageSizeOptions]="pageSizeOptions"
                [maxSize]="maxSize"
                [footerTablePagination]="
                  pagingConfig[getScenarioKey(i)].footerTablePagination
                "
                (handlePaginate)="onHandlePaginate($event, getScenarioKey(i))"
                (handleChangePageSize)="
                  onHandlePageSize($event, getScenarioKey(i))
                "
              ></aran-pagination>
            </div>
          </div>

          <div
            *ngIf="
              (item.oldSubTopicSelectedOption === null ||
                item.oldSubTopicSelectedOption === undefined) &&
              (item.newSubTopicSelectedOption === null ||
                item.newSubTopicSelectedOption === undefined) &&
              item.topicAreas.length === 0
            "
          >
            <div
              class="account__service-value"
              fxLayout="column"
              fxLayoutAlign="start start"
              *ngIf="item.subTopics.length; else noInfoFoundTemplate"
            >
              <ng-container
                *ngIf="
                  (
                    item.subTopics
                    | filterByText : filters[getScenarioKey(i)] : 'description'
                  ).length;
                  else noInfoMatchedFoundTemplate
                "
              >
                <div
                  *ngFor="
                    let service of item.subTopics
                      | filterByText
                        : filters[getScenarioKey(i)]
                        : 'description'
                      | paginate : pagingConfig[getScenarioKey(i)]
                  "
                >
                  <div class="flex items-center">
                    <mat-icon
                      *ngIf="
                        hasAddOrRemoveStatus(
                          item.subTopics
                            | filterByText
                              : filters[getScenarioKey(i)]
                              : 'description'
                            | paginate : pagingConfig[getScenarioKey(i)]
                        )
                      "
                      class="mr-2"
                      [ngClass]="{
                        add_request: service.status === 'Add',
                        removed_request: service.status === 'Remove'
                      }"
                      >{{
                        service.status === "Add"
                          ? "add"
                          : service.status === "Remove"
                          ? "remove"
                          : ""
                      }}</mat-icon
                    >
                    <span
                      [ngClass]="{
                        current_request: service.status === 'Current',
                        add_request: service.status === 'Add',
                        'removed_request line-decoration':
                          service.status === 'Remove'
                      }"
                    >
                      {{ service.description }}
                    </span>
                  </div>
                </div>
              </ng-container>
            </div>

            <div
              class="mt-4 w-full"
              *ngIf="item.subTopics.length > itemsPerPage"
            >
              <aran-pagination
                [uniqueKey]="getScenarioKey(i)"
                [totalItems]="
                  (
                    item.subTopics
                    | filterByText : filters[getScenarioKey(i)] : 'description'
                  ).length
                "
                [currentPage]="pagingConfig[getScenarioKey(i)].currentPage"
                [itemsPerPage]="pagingConfig[getScenarioKey(i)].itemsPerPage"
                [pageSizeOptions]="pageSizeOptions"
                [maxSize]="maxSize"
                [footerTablePagination]="
                  pagingConfig[getScenarioKey(i)].footerTablePagination
                "
                (handlePaginate)="onHandlePaginate($event, getScenarioKey(i))"
                (handleChangePageSize)="
                  onHandlePageSize($event, getScenarioKey(i))
                "
              ></aran-pagination>
            </div>
          </div>
        </ng-template>

        <ng-template #airportsContentTemplate>
          <div
            class="border-bottom py-3 flex"
            *ngIf="
              (item?.topicAreas | areaType : ['Aerodrome', 'Heliport']).length >
                1 &&
              (item.newTopicAreaSelectedOption === 'Custom' ||
                item.oldTopicAreaSelectedOption === 'Custom')
            "
          >
            <div class="detailTableSearchContainer">
              <aran-input
                type="text"
                label="Search"
                fxFlex="100%"
                [outline]="true"
                [isClearable]="true"
                [(ngModel)]="filters[getAirportKey(i)]"
                [ngModelOptions]="{ standalone: true }"
                (input)="applyFilter(getAirportKey(i))"
                (handleReset)="resetFilter(getAirportKey(i))"
              ></aran-input>
            </div>
          </div>

          <div
            class="px-4 pt-4 account__serviceSelectedOption"
            *ngIf="
              item.newTopicAreaSelectedOption &&
              item.newTopicAreaSelectedOption !== 'Custom' &&
              item.newTopicAreaSelectedOption !== 'None' &&
              item.oldTopicAreaSelectedOption !==
                item.newTopicAreaSelectedOption
            "
          >
            <div class="add_request">
              {{ item.newTopicAreaSelectedOption }}
            </div>
          </div>

          <div
            class="px-4 pt-4 account__serviceSelectedOption"
            *ngIf="
              item.oldTopicAreaSelectedOption &&
              item.oldTopicAreaSelectedOption !== 'Custom' &&
              item.oldTopicAreaSelectedOption !== 'None' &&
              item.oldTopicAreaSelectedOption !==
                item.newTopicAreaSelectedOption
            "
          >
            <div class="removed_request line-decoration">
              {{ item.oldTopicAreaSelectedOption }}
            </div>
          </div>

          <div
            class="px-4 pt-4 account__serviceSelectedOption"
            *ngIf="
              item.oldTopicAreaSelectedOption &&
              item.oldTopicAreaSelectedOption !== 'Custom' &&
              item.oldTopicAreaSelectedOption !== 'None' &&
              item.oldTopicAreaSelectedOption ===
                item.newTopicAreaSelectedOption
            "
          >
            <div>
              {{ item.newTopicAreaSelectedOption }}
            </div>
          </div>

          <div
            class="px-4 pt-2 account__serviceSelectedOption"
            *ngIf="
              item.oldTopicAreaSelectedOption === 'Custom' ||
              item.newTopicAreaSelectedOption === 'Custom'
            "
          >
            <div
              [ngClass]="{
                add_request:
                  item.newTopicAreaSelectedOption === 'Custom' &&
                  item.oldTopicAreaSelectedOption !== 'Custom',
                'removed_request line-decoration':
                  item.oldTopicAreaSelectedOption === 'Custom' &&
                  item.newTopicAreaSelectedOption !== 'Custom'
              }"
            >
              Custom
            </div>
          </div>

          <ng-container
            *ngIf="
              (item.newTopicAreaSelectedOption === 'None' &&
                item.oldTopicAreaSelectedOption === 'None') ||
              (item.newTopicAreaSelectedOption === null &&
                item.oldTopicAreaSelectedOption === null) ||
              (item.newTopicAreaSelectedOption === null &&
                item.oldTopicAreaSelectedOption === 'None')
            "
          >
            <ng-container
              *ngTemplateOutlet="noInfoFoundTemplate"
            ></ng-container>
          </ng-container>

          <div
            *ngIf="
              item.oldTopicAreaSelectedOption === 'Custom' ||
              item.newTopicAreaSelectedOption === 'Custom'
            "
          >
            <div
              class="account__service-value"
              fxLayout="column"
              fxLayoutAlign="start start"
              *ngIf="
                (item.topicAreas | areaType : ['Aerodrome', 'Heliport']).length;
                else noInfoFoundTemplate
              "
            >
              <ng-container
                *ngIf="
                  (
                    item.topicAreas
                    | areaType : ['Aerodrome', 'Heliport']
                    | filterBySubTopicStatus
                      : item.oldTopicAreaSelectedOption
                      : item.newTopicAreaSelectedOption
                    | filterByText : filters[getAirportKey(i)] : 'code'
                  ).length;
                  else noInfoMatchedFoundTemplate
                "
              >
                <div
                  *ngFor="
                    let service of item.topicAreas
                      | areaType : ['Aerodrome', 'Heliport']
                      | filterBySubTopicStatus
                        : item.oldTopicAreaSelectedOption
                        : item.newTopicAreaSelectedOption
                      | filterByText : filters[getAirportKey(i)] : 'code'
                      | paginate : pagingConfig[getAirportKey(i)]
                  "
                >
                  <ng-container
                    *ngIf="
                      !(
                        (item.newSubTopicSelectedOption === 'Custom' &&
                          item.oldSubTopicSelectedOption !== 'Custom' &&
                          service.status === 'Remove') ||
                        (item.oldSubTopicSelectedOption === 'Custom' &&
                          item.newSubTopicSelectedOption !== 'Custom' &&
                          service.status === 'Add')
                      )
                    "
                  >
                    <div class="flex items-center">
                      <mat-icon
                        *ngIf="
                          item.newTopicAreaSelectedOption === 'Custom' ||
                          item.oldTopicAreaSelectedOption === 'Custom'
                        "
                        class="mr-2"
                        [ngClass]="{
                          add_request:
                            (item.newTopicAreaSelectedOption === 'Custom' &&
                              item.oldTopicAreaSelectedOption !== 'Custom') ||
                            (item.newTopicAreaSelectedOption === 'Custom' &&
                              item.oldTopicAreaSelectedOption === 'Custom' &&
                              service.status === 'Add'),
                          removed_request:
                            (item.oldTopicAreaSelectedOption === 'Custom' &&
                              item.newTopicAreaSelectedOption !== 'Custom') ||
                            (item.newTopicAreaSelectedOption === 'Custom' &&
                              item.oldTopicAreaSelectedOption === 'Custom' &&
                              service.status === 'Remove')
                        }"
                      >
                        {{
                          (item.newTopicAreaSelectedOption === "Custom" &&
                            item.oldTopicAreaSelectedOption !== "Custom") ||
                          (item.newTopicAreaSelectedOption === "Custom" &&
                            item.oldTopicAreaSelectedOption === "Custom" &&
                            service.status === "Add")
                            ? "add"
                            : (item.oldTopicAreaSelectedOption === "Custom" &&
                                item.newTopicAreaSelectedOption !== "Custom") ||
                              (item.newTopicAreaSelectedOption === "Custom" &&
                                item.oldTopicAreaSelectedOption === "Custom" &&
                                service.status === "Remove")
                            ? "remove"
                            : ""
                        }}
                      </mat-icon>

                      <span
                        [ngClass]="{
                          current_request: service.status === 'Current',
                          add_request:
                            (item.newTopicAreaSelectedOption === 'Custom' &&
                              item.oldTopicAreaSelectedOption !== 'Custom') ||
                            (item.newTopicAreaSelectedOption === 'Custom' &&
                              item.oldTopicAreaSelectedOption === 'Custom' &&
                              service.status === 'Add'),
                          'removed_request line-decoration':
                            (item.oldTopicAreaSelectedOption === 'Custom' &&
                              item.newTopicAreaSelectedOption !== 'Custom') ||
                            (item.newTopicAreaSelectedOption === 'Custom' &&
                              item.oldTopicAreaSelectedOption === 'Custom' &&
                              service.status === 'Remove')
                        }"
                      >
                        {{ service.code }}
                      </span>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>

            <div
              class="mt-4 w-full"
              *ngIf="
                (
                  item?.topicAreas
                  | areaType : ['Aerodrome', 'Heliport']
                  | filterByText : filters[getAirportKey(i)] : 'code'
                ).length > itemsPerPage
              "
            >
              <aran-pagination
                [uniqueKey]="getAirportKey(i)"
                [totalItems]="
                  (
                    item.topicAreas
                    | areaType : ['Aerodrome', 'Heliport']
                    | filterByText : filters[getAirportKey(i)] : 'code'
                  ).length
                "
                [currentPage]="pagingConfig[getAirportKey(i)].currentPage"
                [itemsPerPage]="pagingConfig[getAirportKey(i)].itemsPerPage"
                [pageSizeOptions]="pageSizeOptions"
                [maxSize]="maxSize"
                [footerTablePagination]="
                  pagingConfig[getAirportKey(i)].footerTablePagination
                "
                (handlePaginate)="onHandlePaginate($event, getAirportKey(i))"
                (handleChangePageSize)="
                  onHandlePageSize($event, getAirportKey(i))
                "
              ></aran-pagination>
            </div>
          </div>
        </ng-template>
        <ng-template #firsContentTemplate>
          <div
            class="border-bottom py-3 flex"
            *ngIf="(item?.topicAreas | areaType : 'Airspace').length > 1"
          >
            <div class="detailTableSearchContainer">
              <aran-input
                type="text"
                label="Search"
                fxFlex="100%"
                [outline]="true"
                [isClearable]="true"
                [(ngModel)]="filters[getFirKey(i)]"
                [ngModelOptions]="{ standalone: true }"
                (input)="applyFilter(getFirKey(i))"
                (handleReset)="resetFilter(getFirKey(i))"
              ></aran-input>
            </div>
          </div>

          <div
            class="account__service-value"
            fxLayout="column"
            fxLayoutAlign="start start"
            *ngIf="
              (item.topicAreas | areaType : 'Airspace').length;
              else noInfoFoundTemplate
            "
          >
            <ng-container
              *ngIf="
                (
                  item.topicAreas
                  | areaType : 'Airspace'
                  | filterByText : filters[getFirKey(i)] : 'code'
                ).length;
                else noInfoMatchedFoundTemplate
              "
            >
              <div
                *ngFor="
                  let service of item?.topicAreas
                    | areaType : 'Airspace'
                    | filterByText : filters[getFirKey(i)] : 'code'
                    | paginate : pagingConfig[getFirKey(i)]
                "
              >
                <div class="flex items-center">
                  <mat-icon
                    *ngIf="
                      hasAddOrRemoveStatus(
                        item.topicAreas
                          | areaType : 'Airspace'
                          | filterByText : filters[getFirKey(i)] : 'code'
                          | paginate : pagingConfig[getFirKey(i)]
                      )
                    "
                    class="mr-2"
                    [ngClass]="{
                      add_request: service.status === 'Add',
                      removed_request: service.status === 'Remove'
                    }"
                    >{{
                      service.status === "Add"
                        ? "add"
                        : service.status === "Remove"
                        ? "remove"
                        : ""
                    }}</mat-icon
                  >
                  <span
                    [ngClass]="{
                      current_request: service.status === 'Current',
                      add_request: service.status === 'Add',
                      'removed_request line-decoration':
                        service.status === 'Remove'
                    }"
                  >
                    {{ service.code }}
                  </span>
                </div>
              </div>
            </ng-container>
          </div>

          <div
            class="mt-4 w-full"
            *ngIf="
              (
                item?.topicAreas
                | areaType : 'Airspace'
                | filterByText : filters[getFirKey(i)] : 'code'
              ).length > itemsPerPage
            "
          >
            <aran-pagination
              [uniqueKey]="getFirKey(i)"
              [totalItems]="
                (
                  item.topicAreas
                  | areaType : 'Airspace'
                  | filterByText : filters[getFirKey(i)] : 'code'
                ).length
              "
              [currentPage]="pagingConfig[getFirKey(i)].currentPage"
              [itemsPerPage]="pagingConfig[getFirKey(i)].itemsPerPage"
              [pageSizeOptions]="pageSizeOptions"
              [maxSize]="maxSize"
              [footerTablePagination]="
                pagingConfig[getFirKey(i)].footerTablePagination
              "
              (handlePaginate)="onHandlePaginate($event, getFirKey(i))"
              (handleChangePageSize)="onHandlePageSize($event, getFirKey(i))"
            ></aran-pagination>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</section>

<ng-container>
  <ng-template #updateRequest>
    <app-update
      [requestId$]="selectedElementId"
      targetPage="detail"
    ></app-update>
  </ng-template>

  <aran-drawer-modal
    *ngIf="currentTemplate"
    [isDrawerOpen]="false"
    [templateRef]="currentTemplate"
    [modalTitle]="modalTitle"
  ></aran-drawer-modal>
</ng-container>

<ng-template #noInfoFoundTemplate>
  <ng-container *ngIf="!(isLoading$ | async)">
    <div class="noInfoFound py-2 px-4">No information found</div>
  </ng-container>
</ng-template>

<ng-template #noInfoMatchedFoundTemplate>
  <ng-container *ngIf="!(isLoading$ | async)">
    <div class="noInfoFound py-2">No matching results found</div>
  </ng-container>
</ng-template>
